// ============================================================================
// Campaign Dashboard — real FastAPI + MongoDB backend (Phase 2 · Module A)
// ----------------------------------------------------------------------------
// Source of truth = backend `/api/dashboard/clients` (RBAC + client scope
// enforced server side). A synchronous in-memory cache (hydrated once at auth
// bootstrap) keeps the existing Dashboard UI working unchanged. The pure metric
// helper functions still live in `@/data/mockData` and operate on this shape.
// ============================================================================

import { api } from "@/lib/api";

let _clients = [];
let _hydrated = false;
const _subs = new Set();
const notify = () => _subs.forEach((fn) => { try { fn(); } catch { /* noop */ } });

export const subscribeCampaigns = (fn) => { _subs.add(fn); return () => _subs.delete(fn); };
export const isCampaignsReady = () => _hydrated;

export async function hydrateCampaigns() {
  try {
    const { data } = await api.get("/dashboard/clients");
    const list = Array.isArray(data) ? data : [];
    // Normalizza lo shape del backend (adsets) verso quello atteso dai consumer (adSets),
    // garantendo array sempre presenti per evitare crash su campagne senza ad set/inserzioni.
    _clients = list.map((c) => ({
      ...c,
      meta: c.meta ? {
        ...c.meta,
        campaigns: (c.meta.campaigns || []).map((cp) => ({
          ...cp,
          adSets: (cp.adSets || cp.adsets || []).map((s) => ({ ...s, ads: s.ads || [] })),
        })),
      } : c.meta,
    }));
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error("hydrateCampaigns failed", e?.response?.status);
  } finally {
    _hydrated = true;
    notify();
  }
  return _clients;
}

export const resetCampaigns = () => { _clients = []; _hydrated = false; };
export const getCampaignClients = () => _clients;
export const getCampaignClient = (id) => _clients.find((c) => c.id === id) || null;
